import { render } from "./AdvertizeMaster.vue?vue&type=template&id=fa01bf9c&scoped=true"
import script from "./AdvertizeMaster.vue?vue&type=script&lang=js"
export * from "./AdvertizeMaster.vue?vue&type=script&lang=js"

import "./AdvertizeMaster.vue?vue&type=style&index=0&id=fa01bf9c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa01bf9c"]])

export default __exports__